
import React from 'react';
import { Card } from "@/components/ui/card";
import { Bank } from './types';

interface BankSelectorProps {
  availableBanks: Bank[];
  selectedBank: string | null;
  onBankSelect: (bankId: string) => void;
}

const BankSelector = ({ 
  availableBanks, 
  selectedBank, 
  onBankSelect 
}: BankSelectorProps) => {
  console.log("BankSelector rendered with:", { bankCount: availableBanks.length, selectedBank });
  
  if (!availableBanks.length) {
    console.log("No banks available to display");
    return (
      <div className="py-4 text-amber-600 bg-amber-50 rounded-md px-4 text-center">
        No banks are currently available. Please try again later.
      </div>
    );
  }

  const handleBankClick = (bankId: string, e: React.MouseEvent) => {
    // Stop event propagation
    e.stopPropagation();
    
    console.log("💥 Bank selected:", bankId);
    onBankSelect(bankId);
  };

  return (
    <div className="pt-4">
      <label className="block text-sm font-medium text-gray-700 mb-3">
        Select Bank
      </label>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {availableBanks.map((bank) => (
          <Card 
            key={bank.id} 
            className={`p-4 cursor-pointer transition-colors hover:shadow-md ${
              selectedBank === bank.id ? 'border-blue-500 bg-blue-50' : 'hover:border-blue-300'
            }`}
            onClick={(e) => handleBankClick(bank.id, e)}
            style={{ position: 'relative', zIndex: 10 }}
          >
            <div className="flex flex-col items-center space-y-2">
              <div className="h-12 flex items-center justify-center">
                {bank.logo && (
                  <img 
                    src={bank.logo} 
                    alt={`${bank.name} logo`}
                    className="max-h-full max-w-full object-contain"
                  />
                )}
              </div>
              <span className="text-sm font-medium text-center">{bank.name}</span>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default BankSelector;
